import { Injectable } from "@angular/core";
import { SupportComponent } from "../modal/support.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: "root"
})
export class SupportService {

  constructor(
    public readonly modal: NgbModal,
  ) { }

  public showSupportWindow(): void {
    this.modal.open(
      SupportComponent,
      {
        size: "l",
      }
    );
  }
}
